<template>
  <div>
    This page is 404 Not Found
  </div>
</template>
<script>
export default {
  name: 'notfound'
}
</script>
